<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <usuario-datos-basicos
        v-bind="props"
        v-bind:solo-lectura="soloLectura"
      ></usuario-datos-basicos>
    </v-flex>
    <v-flex xs12>
      <usuario-instituciones
        v-bind="props"
        v-bind:solo-lectura="soloLectura || origen === 'perfil'"
        v-if="!esPaciente()"
      ></usuario-instituciones>
    </v-flex>

  </v-layout>
</template>

<script>

import UsuarioDatosBasicos from './VUsuarioDatosBasicos'

import UsuarioInstituciones from './VUsuarioInstituciones'

export default {
  name: 'VUsuario',
  components: {
    UsuarioDatosBasicos, UsuarioInstituciones
  },
  props: {
    permiso: {
      type: String,
      required: true
    },
    origen: {
      type: String,
      required: true
    },
    operacion: {
      type: String,
      default: 'modif'
    }
  },
  computed: {
    usuario () {
      return this.$store.getters.getUser
    }
  },
  data () {
    return {
      titulo: 'Usuario',
      soloLectura: !this.$puedo(this.permiso + ':modif'),
      props: {
        operacion: this.operacion,
        permiso: this.permiso,
        origen: this.origen
      }
    }
  },
  methods: {
    esPaciente () {
      if (this.usuario && this.usuario.roles.length > 0) {
        return this.usuario.roles.find(obj => {
          return obj.name === 'Paciente'
        }) !== undefined
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.lista-detalle-seccion {
  dt {
    font-size: 14px !important;
    font-weight: 500;
  }
  dd {
    font-size: 13px !important;
    font-weight: 400;
    margin-bottom: 10px;
  }
}
</style>
